import axios from "axios";
import {
  LIQUIDACION_REPORTES_DETALLADO_BASE_URL,
  LIQUIDACION_REPORTES_DETALLADO_EXPORT_PATH,
  LIQUIDACION_REPORTES_DETALLADO_PATH,
  LIQUIDACION_REPORTES_RESUMEN_BASE_URL,
  LIQUIDACION_REPORTES_RESUMEN_EXPORT_PATH,
  LIQUIDACION_REPORTES_RESUMEN_PATH,
  LIQUIDACION_REPORTES_REQUEST_TIMEOUT,
  RESUMEN_DEFAULT_PER_PAGE,
  MESSAGES,
} from "./liquidacion-reportes.constants";
import {
  buildReportExportBody,
  buildReportQueryParams,
  parseApiErrorMessage,
  resolvePagedTotal,
} from "./liquidacion-reportes.contract";
import {
  mapApiDetalladoResponse,
  mapApiResumenResponse,
} from "./liquidacion-reportes.mapper";
import {
  saveDetalladoExportBlob,
  saveResumenExportBlob,
} from "./liquidacion-reportes.excel";

const JSON_HEADERS = { "Content-type": "application/json" };

const REQUEST_CONFIG = {
  headers: JSON_HEADERS,
  timeout: LIQUIDACION_REPORTES_REQUEST_TIMEOUT,
};

function buildApiUrl(base, path, envName) {
  if (!base) {
    throw new Error(`Falta la variable de entorno ${envName}.`);
  }

  return `${base}${path}`;
}

function buildQueryString(params = {}) {
  const entries = Object.entries(params).filter(
    ([, value]) => value !== null && value !== undefined && value !== "",
  );

  if (!entries.length) return "";

  const query = entries
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");

  return `?${query}`;
}

export function getLiquidacionReportesErrorMessage(error) {
  return parseApiErrorMessage(error, MESSAGES.LOAD_ERROR);
}

function normalizePagination(pagination = {}) {
  return {
    page: pagination.page ?? 1,
    limit: pagination.limit ?? pagination.perPage ?? RESUMEN_DEFAULT_PER_PAGE,
  };
}

function mapPagedApiResponse(response, mapRows, pagination = {}) {
  const items = mapRows(response);
  const total = resolvePagedTotal(response, items, pagination);

  return { items, total };
}

async function getReport(
  baseUrl,
  path,
  envName,
  filters = {},
  pagination = {},
  options = {},
) {
  const params = buildReportQueryParams(filters, pagination, options);
  const url =
    buildApiUrl(baseUrl, path, envName) + buildQueryString(params);
  const { data } = await axios.get(url, REQUEST_CONFIG);

  return data;
}

export async function fetchLiquidacionResumen(
  filters = {},
  pagination = {},
  options = {},
) {
  const paging = normalizePagination(pagination);
  const response = await getReport(
    LIQUIDACION_REPORTES_RESUMEN_BASE_URL,
    LIQUIDACION_REPORTES_RESUMEN_PATH,
    "VUE_APP_LIQUIDACION_REPORTES_RESUMEN_BASE",
    filters,
    paging,
    options,
  );

  return mapPagedApiResponse(response, mapApiResumenResponse, paging);
}

export async function fetchLiquidacionDetallado(
  filters = {},
  pagination = {},
  options = {},
) {
  const paging = normalizePagination(pagination);
  const response = await getReport(
    LIQUIDACION_REPORTES_DETALLADO_BASE_URL,
    LIQUIDACION_REPORTES_DETALLADO_PATH,
    "VUE_APP_LIQUIDACION_REPORTES_DETALLADO_BASE",
    filters,
    paging,
    options,
  );

  return mapPagedApiResponse(response, mapApiDetalladoResponse, paging);
}

export async function exportLiquidacionResumen(filters = {}, options = {}) {
  const url = buildApiUrl(
    LIQUIDACION_REPORTES_RESUMEN_BASE_URL,
    LIQUIDACION_REPORTES_RESUMEN_EXPORT_PATH,
    "VUE_APP_LIQUIDACION_REPORTES_RESUMEN_BASE",
  );
  const payload = buildReportExportBody(filters, options);

  const { data } = await axios.post(url, payload, {
    ...REQUEST_CONFIG,
    responseType: "blob",
  });

  await saveResumenExportBlob(data);
}

export async function exportLiquidacionDetallado(filters = {}, options = {}) {
  const url = buildApiUrl(
    LIQUIDACION_REPORTES_DETALLADO_BASE_URL,
    LIQUIDACION_REPORTES_DETALLADO_EXPORT_PATH,
    "VUE_APP_LIQUIDACION_REPORTES_DETALLADO_BASE",
  );
  const payload = buildReportExportBody(filters, options);

  const { data } = await axios.post(url, payload, {
    ...REQUEST_CONFIG,
    responseType: "blob",
  });

  await saveDetalladoExportBlob(data);
}
